import { handlePageTitle } from "containers/cardOnboarding/services/data.transformers";
import { useTranslation } from "react-i18next";
import PageHeader from "./header";
import { Layout } from "antd";
import { useEffect, useState } from "react";

const { Content } = Layout;
const PageLayout = ({
  children,
  current,
  data,
  steps,
  goBack,
  onCloseOnboarding,
}) => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Layout className="items-center !bg-white ">
      <PageHeader
        onCloseOnboarding={onCloseOnboarding}
        title={handlePageTitle(data, current, steps, t)}
        goBack={goBack}
        steps={steps}
        isScrolled={isScrolled}
      />
      <Layout className="w-full max-w-2xl  bg-white">
        <Content className="  overflow-auto overflow-x-hidden pb-24">
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};
export default PageLayout;
